module.exports = __webpack_public_path__ + "media/images/flags/32/Greenland-1a0d165c51f791b9968b7280b39ccd5b.png";